export const PROMO_END_DATE = new Date('December 25, 2024 23:59:59');
export const PROMO_CODE = 'WINTER50';
export const PROMO_DISCOUNT = 0.5;
